import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

const COLS = [
  {
    title: "Studio",
    links: [
      ["Work", "#showcase"],
      ["Craft", "#features"],
      ["Process", "#manifesto"],
      ["Journal", "#testimonials"],
    ],
  },
  {
    title: "Elsewhere",
    links: [
      ["Twitter / X", "#"],
      ["Instagram", "#"],
      ["Are.na", "#"],
      ["Read.cv", "#"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Imprint", "#"],
      ["Privacy", "#"],
      ["Terms of service", "#"],
      ["Colophon", "#"],
    ],
  },
];

const Footer = () => {
  const [time, setTime] = useState("");
  useEffect(() => {
    const tick = () => {
      const d = new Date();
      const utc = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
      const berlin = new Date(utc.getTime() + 3600000);
      const hh = berlin.getHours().toString().padStart(2, "0");
      const mm = berlin.getMinutes().toString().padStart(2, "0");
      const ss = berlin.getSeconds().toString().padStart(2, "0");
      setTime(`${hh}:${mm}:${ss}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer
      data-testid="footer-container"
      className="relative overflow-hidden border-t border-white/5 bg-[#040406] pt-20"
    >
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 lg:gap-14 pb-16">
          <div>
            <Logo size={30} />
            <p className="mt-6 text-[14px] leading-relaxed text-[#8A8D98] max-w-[36ch]">
              A two-person static web studio — Berlin, remote. We ship two
              sites a month, and only ones we'd put on our own page.
            </p>
            <a
              href="mailto:studio@zcrazy.com"
              className="mt-6 inline-flex items-center gap-1.5 font-display text-2xl sm:text-3xl font-medium tracking-tight text-[#F4F4F2] hover:text-accent transition-colors"
            >
              studio@zcrazy.com
              <ArrowUpRight size={20} className="text-accent" />
            </a>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <div className="mono-label mb-5">{col.title}</div>
              <ul className="space-y-3">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      className="group inline-flex items-center gap-1 text-[14px] text-[#C9CBD3] hover:text-accent transition-colors"
                    >
                      {label}
                      <ArrowUpRight
                        size={12}
                        className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#5A5D68]">
          <div>© 2026 Z Crazy Studio · All rights reserved</div>
          <div className="flex items-center gap-3">
            <span className="h-1.5 w-1.5 rounded-full bg-accent animate-pulse" />
            BERLIN · {time} CET
          </div>
          <div>Made with HTML &amp; stubborn taste</div>
        </div>
      </div>

      {/* Giant faded wordmark */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 2 }}
        className="relative overflow-hidden -mt-6"
      >
        <div className="wordmark-giant mx-auto text-center -mb-[2vw]">
          Z CRAZY
        </div>
      </motion.div>
    </footer>
  );
};

export default Footer;
